import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import ActionButton from '@/components/misc/ActionButton'
import { Button } from '@/components/ui/button'
import { faPlus } from '@/lib/fontAwesomePro/regular'
import { cn } from '@/lib/utils'
import { useAcceptRecommendedPartnerMutation } from '@/pages/professionalNetworkRelationships/hooks/useAcceptRecommendPartnerMutation'
import { useRecommendedPartner } from '@/pages/professionalNetworkRelationships/hooks/useRecommendedPartner'

type Props = Omit<React.ComponentProps<typeof Button>, 'children' | 'ref'>

const AddToReferralPartnersButton: React.FC<Props> = ({
  className,
  size = 'lg',
  ...props
}) => {
  const partner = useRecommendedPartner()
  const acceptMutation = useAcceptRecommendedPartnerMutation()

  return (
    <ActionButton
      isProcessing={acceptMutation.isPending}
      isProcessingText="Adding to referral partners"
      onClick={() =>
        acceptMutation.mutate({
          partnerId: partner.id,
          partnerName: partner.company.presentationName,
        })
      }
      className={cn(
        'flex w-full items-center justify-center gap-2 sm:w-auto',
        className,
      )}
      size={size}
      {...props}
    >
      <FontAwesomeIcon icon={faPlus} />
      Add to referral partners
    </ActionButton>
  )
}

export default AddToReferralPartnersButton
